import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img04.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#644296" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Turn Your Innovative Business Ideas Into Compelling Digital
              Solutions
            </h2>
            <p>
              TekRevol is amongst the fastest-growing tech corporations in the
              USA and has benefited various clients worldwide. With use cases as
              practical as AI-based learning SaaS, to as modern as waste
              management mobile applications, we give our clients access to a
              forward-thinking team and a contemporary technology stack based on
              Deep Learning, Extended Reality, decentralized ledgers, the
              Internet of Things, and Robotics.
            </p>
            <p>
              We have empowered AI startup founders, game entrepreneurs, and
              tech venture capitalists in this fastest-growing tech hub of the
              USA.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#644296",
                border: "1px solid #644296",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
